<template lang="pug">
section
  s-page-title(title='Вакансии')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
        template(slot='controls')
          
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.region_name }}
          td {{ props.item.name }}
          td {{ props.item.full_salary }}
          td {{ props.item.published_at }}

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='job/vacancies'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Регион',
        align: 'left',
        sortable: true,
        value: 'region_id'
      },
      {
        text: 'Вакансия',
        align: 'left',
        value: 'name',
        width: '100%',
        sortable: true
      },
      {
        text: 'Зарплата',
        align: 'left',
        value: 'salary_min',
        width: '0%',
        sortable: true
      },
      {
        text: 'Дата публикации',
        align: 'left',
        value: 'published_at',
        width: '0%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Job.Vacancies.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('job/vacancies', ['fetchList', 'destroy']),
    ...mapMutations('job/vacancies', ['setDataFilter'])
  },

  computed: {
    ...mapState('job/vacancies', ['total', 'dataFilter']),
    ...mapGetters('job/vacancies', ['list', 'isLoading'])
  }
}
</script>
